export default __webpack_public_path__ + "static/media/707.fd9438b2.gif";